// extracted by mini-css-extract-plugin
export default {"root":"m1_FI","header":"_1YOOD","headerContent":"_1xb8A","title":"_33oAE","scrollbar":"-sXUq","instruction":"lACeO"};